import PropTypes from "prop-types";
import { useCallback, useMemo } from "react";
import {
  TbBrandFacebook,
  TbBrandPinterest,
  TbBrandWhatsapp,
  TbBrandX,
  TbMail,
  TbQrcode,
  TbShare,
} from "react-icons/tb";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  facebookShare,
  openShareWindow,
  pinterestShare,
  twitterShare,
  whatsAppShare,
} from "../../tools/func";
import CopyButton from "./CopyButton";
import useToggle from "./hooks/useToggle";
import QrCodeModal from "./qrcodeloader/QRCodeModal";
import SocialShareIcon from "./SocialShareIcon";

function ShareBar({ link, noCopy }) {
  const [showQrModal, toggle] = useToggle();
  const canShare = useMemo(() => {
    const data = {
      url: link,
    };
    return "canShare" in navigator && navigator.canShare(data);
  }, [link]);
  const store_logo = useSelector((state) => state.settings.store_logo);
  const doShare = useCallback(
    (type) => {
      return () => {
        switch (type) {
          case "facebook":
            openShareWindow(
              facebookShare(link),
              "facebook",
              "width=500, height=500",
            );
            break;
          case "twitter":
            openShareWindow(
              twitterShare(link),
              "twitter",
              "width=600,height=300",
            );
            break;
          case "pinterest":
            openShareWindow(
              pinterestShare(link, "", store_logo),
              "pinterest",
              "width=600,height=300",
            );
            break;
          case "whatsapp":
            window.open(whatsAppShare(link));
            break;
        }
      };
    },
    [link],
  );

  const navigatorShare = () => {
    const data = {
      url: link,
    };
    if ("canShare" in navigator && navigator.canShare(data)) {
      navigator.share(data).catch((e) => {
        console.log(e);
      });
    }
  };
  const intl = useIntl();
  const shareOnMail = () => {
    window.open("mailto:?body=" + link);
  };
  const [visible, toggleVisible] = useToggle();

  return (
    <div className="d-flex">
      {!noCopy ? (
        <CopyButton
          style={{ fontSize: "0.9rem", width: 60, textAlign: "left" }}
          text={link}
        />
      ) : null}
      <div>
        <button
            type={"button"}
          className="btn"
          onClick={toggleVisible}
          title={intl.formatMessage({ id: "Share" })}
        >
          <TbShare style={{ width: 20, height: 20 }} />
        </button>

        {/* {canShare ? (
          <SocialShareIcon
            Cmp={<TbShare3 style={{ width: 20, height: 20 }} />}
            disabled={!link}
            onClick={navigatorShare}
            alt={"Share"}
          />
        ) : null} */}
        {visible ? (
          <>
            <SocialShareIcon
              Cmp={<TbBrandFacebook style={{ width: 20, height: 20 }} />}
              disabled={!link}
              onClick={doShare("facebook")}
              alt={"Facebook"}
            />
            <SocialShareIcon
              Cmp={<TbBrandX style={{ width: 20, height: 20 }} />}
              disabled={!link}
              onClick={doShare("twitter")}
              alt={"X (formerly Twitter)"}
            />
            <SocialShareIcon
              Cmp={<TbBrandPinterest style={{ width: 20, height: 20 }} />}
              disabled={!link}
              onClick={doShare("pinterest")}
              alt={"Pinterest"}
            />
            <SocialShareIcon
              Cmp={<TbBrandWhatsapp style={{ width: 20, height: 20 }} />}
              disabled={!link}
              onClick={doShare("whatsapp")}
              alt={"WhatsApp"}
            />
            <SocialShareIcon
              Cmp={<TbQrcode style={{ width: 20, height: 20 }} />}
              disabled={!link}
              onClick={toggle}
              alt={"QR Code"}
            />
            <SocialShareIcon
              Cmp={<TbMail style={{ width: 20, height: 20 }} />}
              alt={"Mail"}
              disabled={!link}
              onClick={shareOnMail}
            />
          </>
        ) : null}
      </div>
      <QrCodeModal value={link} onClose={toggle} visible={showQrModal} />
    </div>
  );
}

ShareBar.propTypes = {
  link: PropTypes.string.isRequired,
};

export default ShareBar;
